import { useTranslation } from 'react-i18next';
import React from 'react';
import { Modal } from '../ui/Modal';
import {
  ErrorModalContent,
  ModalMessage,
  modalStyles,
  ModalTitle
} from './styled';
import useScreenSize from '../../hooks/useScreenSize';
import { Button } from '../ui/Button';

interface ErrorPopupProps {
  isOpen: boolean;
  isBannedPhone?: boolean;
  title?: string;
  message?: string;
  onClose: () => void;
}

export const ErrorPopup: React.FC<ErrorPopupProps> = ({
  isOpen,
  title,
  isBannedPhone,
  message,
  onClose
}) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();

  const modalId = isBannedPhone ? 'banned-number-modal' : 'error-modal';
  const modalTitle = isBannedPhone ? t('pages.current_item.attention') : title;
  const modalMessage = isBannedPhone
    ? t('new_ad.banned_phone_message')
    : message;

  return (
    <Modal
      modalId={modalId}
      isOpen={isOpen}
      modalStyles={modalStyles}
      onClose={onClose}
      cypress={modalId}
    >
      <ErrorModalContent>
        <ModalTitle tag={isSmall ? 'h5_new' : 'h9'}>{modalTitle}</ModalTitle>
        <ModalMessage tag="body_1">{modalMessage}</ModalMessage>
        <Button
          text={t('pages.current_item.buttons.accepted')}
          onClick={onClose}
        />
      </ErrorModalContent>
    </Modal>
  );
};
